<template>
  <div>
    <div class="bg-gray shadow-sm overflow-hidden sm:rounded-lg">
      <div class="border-t border-gray-200 bg-white">
        <Loading v-if="loading" />
        <div v-else-if="claims.length === 0" class="text-center py-1">
          <span class="text-gray-900 text-xs font-bold">Aucun sinistre</span>
        </div>
        <PaginatedClaimList
          v-else
          :claims="claims"
          :current-page="currentPage"
          :total-count="totalCount"
          :total-pages="totalPages"
          @changePage="fetchClaims"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginatedClaimList from "@/components/claim/list/PaginatedClaimList.vue";
import { Loading } from "@estaly/ui";
import { toCamelCase } from "@/utils/utils";
import { mapActions } from "vuex";

export default {
  components: {
    PaginatedClaimList,
    Loading,
  },
  props: {
    planSaleFriendlyId: {
      type: String,
      required: true,
    },
    excludeClaimId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      claims: [],
      totalCount: 1,
      totalPages: 1,
      currentPage: 1,
    };
  },
  watch: {
    async planSaleFriendlyId() {
      await this.fetchClaims();
    },
    async excludeClaimId() {
      await this.fetchClaims();
    },
  },
  async mounted() {
    await this.fetchClaims();
  },
  methods: {
    ...mapActions("claims", ["fetchIndex"]),

    async fetchClaims(page = 1) {
      this.loading = true;
      const response = await this.fetchIndex({ page, planSaleFriendlyId: this.planSaleFriendlyId });

      if (!response?.success) return;

      const responseData = toCamelCase(response.data);
      let filteredClaims = responseData.claims;
      if (this.excludeClaimId) {
        filteredClaims = responseData.claims.filter((claim) => claim.friendlyId !== this.excludeClaimId);
      }

      this.claims = filteredClaims;
      this.totalCount = responseData.page.totalCount;
      this.totalPages = responseData.page.totalPages;
      this.currentPage = responseData.page.currentPage;

      this.loading = false;
    },
  },
};
</script>
